import React from 'react';

const Booking: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white shadow rounded-lg p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Book a Session</h1>
        <p className="text-gray-600 mb-6">
          Schedule a session with one of our mental health experts.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <h3 className="text-lg font-medium text-gray-900">Available Sessions</h3>
            <div className="space-y-2">
              <div className="p-4 border border-gray-200 rounded-lg">
                <h4 className="font-medium">Individual Counseling</h4>
                <p className="text-sm text-gray-600">One-on-one session with a licensed therapist</p>
              </div>
              <div className="p-4 border border-gray-200 rounded-lg">
                <h4 className="font-medium">Group Therapy</h4>
                <p className="text-sm text-gray-600">Join a supportive group session</p>
              </div>
            </div>
          </div>
          
          <div className="space-y-4">
            <h3 className="text-lg font-medium text-gray-900">Calendar</h3>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="text-gray-600">Calendar integration will be available here</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Booking;
